import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SiteHeader = _resolveComponent("SiteHeader")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mainContainer", { mainBackground: _ctx.needsMainBackground }])
  }, [
    _createVNode(_component_SiteHeader),
    _createElementVNode("main", null, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 2))
}